import { render } from "./MintSkeleton.vue?vue&type=template&id=5b8dcb93&scoped=true"
import script from "./MintSkeleton.vue?vue&type=script&lang=js"
export * from "./MintSkeleton.vue?vue&type=script&lang=js"

import "./MintSkeleton.vue?vue&type=style&index=0&id=5b8dcb93&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8dcb93"]])

export default __exports__